import { Component, Input } from '@angular/core';
import { SystemModel, Ticket, TicketLog } from 'src/app/models';
import { ToastService } from '@teorema/patron';
import { TicketLogTimePipe } from '../../../pipes/ticket-log-time.pipe';
import moment from 'moment';

@Component({
  selector: 'app-system-percentages',
  templateUrl: './system-percentages.component.html',
  standalone: false,
})
export class SystemPercentagesComponent {
  @Input() inputSystem?: SystemModel;
  @Input() currentTicketLog?: TicketLog;
  @Input() entity!: Ticket;
  @Input() loading: boolean = false;

  systemsPercentages: any[] = [];
  dragData?: any;

  constructor(
    private toastService: ToastService,
    private ticketLogTimePipe: TicketLogTimePipe
  ) {}

  reset() {
    this.systemsPercentages = [];
  }

  validate() {
    let spWithZero = this.systemsPercentages.find(sp => sp.percentage <= 0);
    if (spWithZero) {
      this.toastService.show({
        color: 'error',
        message: 'O sistema ' + spWithZero.description + ' está com porcentagem 0 ou negativa',
      });
      return false;
    }

    return true;
  }

  setDefaultSystemsPercentage() {
    if (!this.inputSystem && this.currentTicketLog?.task?.id) {
      let task = this.entity.tasks?.find(t => t.id === this.currentTicketLog?.task?.id);

      if (task && task.systems?.length && task.systems?.length > 1) {
        this.systemsPercentages = task.systems.map(s => {
          return {
            system: s,
          };
        });
        this.calculateSystemPercentages();
      }
    }
  }

  calculateSystemPercentages() {
    let percentagePerSystem = Math.floor(100 / this.systemsPercentages.length);
    let sum = 0;

    for (let i = 0; i < this.systemsPercentages.length; i++) {
      if (i >= this.systemsPercentages.length - 1) {
        this.systemsPercentages[i].percentageRange = [sum, 100];
      } else {
        this.systemsPercentages[i].percentageRange = [sum, sum + percentagePerSystem];
        sum += percentagePerSystem;
      }
    }

    this.updateSystemPercentageLabels();
  }

  updateSystemPercentageLabels() {
    if (this.currentTicketLog?.start_date) {
      let start_date = new Date(this.currentTicketLog?.start_date);
      let totalLogTime = new Date().getTime() - start_date.getTime();

      this.systemsPercentages.forEach(s => {
        s.percentage = s.percentageRange[1] - s.percentageRange[0];
        let time = Math.floor((totalLogTime * s.percentage) / 100);
        s.timeLabel = this.ticketLogTimePipe.getDaysHoursAndMinutesFromTime(time);
      });
    }
  }

  deleteSystemPercentage(sp, i) {
    if (this.systemsPercentages.length === 1) return;

    if (sp.confirmDelete) {
      this.systemsPercentages.splice(i, 1);
      this.calculateSystemPercentages();
    } else {
      sp.confirmDelete = true;
    }
  }

  systemPercentageChanged(index, sp, event) {
    if (sp.percentageRange[1] < sp.percentageRange[0]) {
      let temp = sp.percentageRange[0];
      sp.percentageRange[0] = sp.percentageRange[1];
      sp.percentageRange[1] = temp;
    }

    for (let i = index - 1; i > -1; i--) {
      let range = this.systemsPercentages[i].percentageRange;
      range[1] = this.systemsPercentages[i + 1].percentageRange[0];
      range[0] = Math.min(range[0], range[1]);
    }

    for (let i = index + 1; i < this.systemsPercentages.length; i++) {
      let range = this.systemsPercentages[i].percentageRange;
      range[0] = this.systemsPercentages[i - 1].percentageRange[1];
      range[1] = Math.max(range[0], range[1]);
    }

    this.systemsPercentages[0].percentageRange[0] = 0;
    this.systemsPercentages[this.systemsPercentages.length - 1].percentageRange[1] = 100;

    this.updateSystemPercentageLabels();

    let temp = this.systemsPercentages;
    this.systemsPercentages = [];

    setTimeout(() => {
      //Sem isso não atualiza o slider em tela
      this.systemsPercentages = temp;
    }, 1);
  }

  setSystemPercentagesDates(startDateTime?: number, endDateTime?: number) {
    if (!startDateTime || !endDateTime || !this.systemsPercentages.length) {
      return;
    }

    let totalLogTime = endDateTime - startDateTime;

    for (let i = 0; i < this.systemsPercentages.length; i++) {
      let s = this.systemsPercentages[i];

      if (i == 0) {
        s.start_date = startDateTime;
      } else {
        s.start_date = this.systemsPercentages[i - 1].end_date;
      }

      if (i >= this.systemsPercentages.length - 1) {
        s.end_date = endDateTime;
      } else if (s.percentage) {
        let time = Math.floor((totalLogTime * s.percentage) / 100);
        s.end_date = s.start_date + time;
      }

      //Chamado 0000523472
      if (s.end_date && s.start_date > s.end_date) {
        console.log('Apontamento com datas invertidas: ');
        console.log(s);
        let temp = s.end_date;
        s.end_date = s.start_date;
        s.start_date = temp;
      }
    }

    this.systemsPercentages.forEach(sp => {
      sp.start_date = moment(sp.start_date).local().format().substring(0, 19);
      sp.end_date = moment(sp.end_date).local().format().substring(0, 19);
    });

    return this.systemsPercentages;
  }

  getSaveBody(formTicketLog: TicketLog, sp: any, i: number) {
    let body = JSON.parse(JSON.stringify(formTicketLog));
    body.start_date = sp.start_date;
    body.end_date = sp.end_date;
    body.system = sp.system;

    if (i > 0) {
      body.id = null;
      body.created_at = null;
    }

    return body;
  }

  onDragStart(dragData: any) {
    this.dragData = dragData;
  }

  onDrop(dropData: any) {
    if (this.dragData && this.dragData.sourceIndex !== dropData.targetIndex) {
      let temp = this.systemsPercentages[dropData.targetIndex].system;
      this.systemsPercentages[dropData.targetIndex].system =
        this.systemsPercentages[this.dragData.sourceIndex].system;
      this.systemsPercentages[this.dragData.sourceIndex].system = temp;
    }
  }
}
